import colors from '@magoosh/lib/styles/colors.module.scss';

export default (examName: string, sections: string) => {
  if (examName === 'GMAT') {
    const quant = {
      label: 'Quantitative Reasoning',
      percentage: true,
      value: 100
    };
    const verbal = {
      label: 'Verbal Reasoning',
      percentage: true,
      value: 100
    };
    const data = {
      label: 'Data',
      percentage: true,
      value: 100
    };

    if (!sections || sections === 'all') {
      return [quant, verbal, data];
    }

    let result = [];

    if (sections.indexOf('quantitative_reasoning') !== -1){
      result.push(quant);
    }
    if (sections.indexOf('verbal_reasoning') !== -1) {
      result.push(verbal);
    }
    if (sections.indexOf('data_insights') !== -1) {
      result.push(data);
    }

    return result;
  } else if (examName === 'GRE') {
    const math = {
      label: 'Math',
      percentage: true,
      value: 100
    };
    const verbal = {
      label: 'Verbal',
      percentage: true,
      value: 100
    };

    if (!sections || sections === 'all') {
      return [math, verbal];
    }

    let result = [];

    if (sections.indexOf('math') !== -1) {
      result.push(math);
    }
    if (sections.indexOf('verbal') !== -1) {
      result.push(verbal);
    }

    return result;
  } else if (examName === 'SAT') {
    const reading_writing = {
      label: 'Reading & Writing',
      percentage: true,
      value: 100
    };
    const math = {
      label: 'Math',
      percentage: true,
      value: 100
    };
    if (!sections || sections === 'all') {
      return [reading_writing, math];
    }

    let result = [];

    if (sections.indexOf('reading_and_writing') !== -1) {
      result.push(reading_writing);
    }
    if (sections.indexOf('math') !== -1){
      result.push(math);
    }

    return result;
  } else if (examName === 'TOEFL') {
    const reading = {
      label: 'Reading',
      percentage: true,
      value: 100
    };
    const listening = {
      label: 'Listening',
      percentage: true,
      value: 100
    };
    const speaking = {
      label: 'Speaking',
      percentage: true,
      value: 100
    };
    const writing = {
      label: 'Writing',
      percentage: true,
      value: 100
    };

    if (!sections || sections === 'all') {
      return [reading, listening, speaking, writing];
    }

    let result = [];

    if (sections.indexOf('reading') !== -1) {
      result.push(reading);
    }
    if (sections.indexOf('listening') !== -1){
      result.push(listening);
    }
    if (sections.indexOf('speaking') !== -1){
      result.push(speaking);
    }
    if (sections.indexOf('writing') !== -1){
      result.push(writing);
    }

    return result;
  } else {
    return [];
  }
};
